import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';

import moment from 'moment';
import 'moment-duration-format';

import SurveyQuestion from '../../../../components/v3/TakingSurvey/SurveyQuestion';

import {
    updateProps,
    loadAgentSurveyScreen,
    submitAgentSurvey
} from './AgentSurveyScreenActions';
import { arrayIsNotEmpty, isDefined, pageLoaded } from '../../../../utils';
import LoadingControl from '../../../../components/LoadingControl';

class AgentSurveyScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            updateState: false,
            surveyIsSubmitting: false,
            ani: undefined,
            lastAni: undefined,
            selectedReasonForContactId: undefined,
            surveyResult: {
                surveyFields: []
            },
        };

        this.onSelectOption = this.onSelectOption.bind(this);
        this.onSubmitSurvey = this.onSubmitSurvey.bind(this);
        this.allRequiredQuestionsAreAnswered = this.allRequiredQuestionsAreAnswered.bind(this);
        this.getSurveyFormNode = this.getSurveyFormNode.bind(this);
        this.updateAni = this.updateAni.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.setLoadingToFalse = this.setLoadingToFalse.bind(this);
    }

    componentDidMount() {
        pageLoaded('Agent Predictions');
        this.props.dispatch(loadAgentSurveyScreen());
    }

    updateAni({ target }) {
        this.setState({ ani: target.value });
    }

    handleSelectChange({ target }) {
        this.setState({ selectedReasonForContactId: target.value });
    }

    allRequiredQuestionsAreAnswered() {
        const
            {
                agentSurveyFormQuestions,
            } = this.props;

        if (!isDefined(agentSurveyFormQuestions) || !isDefined(this.state.surveyResult.surveyFields)) {
            return false;
        }

        if (!isDefined(this.state.ani) || this.state.ani === '') {
            return false;
        }

        if (!isDefined(this.state.selectedReasonForContactId) || this.state.selectedReasonForContactId === '') {
            return false;
        }

        //const isRequiredAnsweredQuestions = agentSurveyFormQuestions.filter(sq => sq.isRequiredAnswered === true);

        const allRespondedQuestionIds = this.state.surveyResult.surveyFields.map(sf => sf.surveyQuestionId);

        let allRequiredAreAnswered = agentSurveyFormQuestions.every(v => allRespondedQuestionIds.includes(v.id));

        return allRequiredAreAnswered;
    }

    setLoadingToFalse() {
        this.setState({
            surveyIsSubmitting: false,
            ani: undefined,
            selectedReasonForContactId: undefined,
            surveyResult: {
                surveyFields: []
            },
        });
    }

    onSubmitSurvey() {
        this.setState({ surveyIsSubmitting: true, lastAni: this.state.ani });
        this.state.surveyResult.ani = this.state.ani;
        this.state.surveyResult.reasonForContactId = this.state.selectedReasonForContactId;
        this.props.dispatch(submitAgentSurvey(this.state.surveyResult, this.setLoadingToFalse));
    }

    onSelectOption(surveyQuestionId, maxPoints, surveyQuestionPotentialResponseId) {
        const surveyField = {
            surveyQuestionId: surveyQuestionId,
            surveyQuestionPotentialResponseId: surveyQuestionPotentialResponseId,
        }

        this.state.surveyResult.surveyFields = this.state.surveyResult.surveyFields.filter(sf => sf.surveyQuestionId != surveyQuestionId);
        this.state.surveyResult.surveyFields.push(surveyField);

        this.setState({ updateState: !this.state.updateState });
    }

    getSurveyFormNode() {
        const
            {
                agentSurveyFormQuestions,
                reasonsForContact
            } = this.props;
        if (this.state.surveyIsSubmitting === true || !isDefined(agentSurveyFormQuestions)) {
            return <div className="flex justify-content-center" style={{ height: '398px', backgroundColor: 'rgb(252,252,255)' }}>
                <img src="../../../../../../Assets/Images/V3Design/Zac.gif" width="350" />
            </div>;
        }
        let submitSurveyButton;

        const enabledsubmitSurveyButton = (
            <div className="v3-button session-required" style={{ borderRadius: '10px' }}
                onClick={this.onSubmitSurvey}>
                <label className="h3-semibold white-text cursor-pointer">Submit</label>
            </div>);

        const disabledsubmitSurveyButton = (
            <div className="v3-button session-required-disabled" style={{ cursor: 'auto', borderRadius: '10px' }}>
                <label className="h3-semibold grey-text" >Submit</label>
            </div >);


        submitSurveyButton = (this.state.surveyIsSubmitting || !this.allRequiredQuestionsAreAnswered())
            ? disabledsubmitSurveyButton : enabledsubmitSurveyButton;

        let sectionQuestions = <LoadingControl />;
        if (arrayIsNotEmpty(agentSurveyFormQuestions)) {
            sectionQuestions = agentSurveyFormQuestions.map((sq, index) => {
                return <SurveyQuestion
                    key={sq.id}
                    surveyQuestion={sq}
                    surveyQuestionNumberInForm={index}
                    onSelectOption={this.onSelectOption}
                    showScore={false} />
            });
        }

        return (<div>
            <div className="flex ">
                {/*<label style={{ marginLeft: '10px', marginRight: '9px' }}*/}
                {/*    className="teams-table-for-manager all-teams-title">ANI: </label>*/}
                <input
                    type="text"
                    id={1}
                    placeholder="Active #"
                    value={this.state.ani}
                    onChange={this.updateAni}
                    className="text-input"
                    autoComplete="off"
                    style={{ padding: '0 12px', fontSize: '24px' }} />
                {isDefined(this.state.lastAni) && this.state.lastAni === this.state.ani && (
                    <div style={{ color: 'red', marginLeft: '5px' }}>Same Call Back # as the previous call!</div>
                )}
                <div style={{ marginLeft: '18px' }}>
                    <select value={this.state.selectedReasonForContactId} onChange={this.handleSelectChange} className="dropdown_list">
                        <option value="">Select Contact Reason</option>
                        {reasonsForContact && reasonsForContact.map((option) => (
                            <option key={option.id} value={option.id}>
                                {option.parentName} - {option.name}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            <br />
            {sectionQuestions}
            <br />
            {submitSurveyButton}
        </div>);

    }

    render() {
        const
            {
            } = this.props;
        if (this.state.surveyIsSubmitting) {
            return <div className="flex justify-content-center" style={{ height: '398px', backgroundColor: 'rgb(252,252,255)' }}>
                <img src="../../../../../../Assets/Images/V3Design/Zac.gif" width="350" />
            </div>;
        }
        const surveyFormNode = this.getSurveyFormNode();

        return (<div style={{ margin: '20px 50px' }}>
            {surveyFormNode}
        </div>);
    }
}

const select = state => ({ ...state.AgentSurveyScreen });

export default connect(select)(AgentSurveyScreen);